import { OrderWithContext } from '@/models';
import { AnalyticsEvent } from '../models';

export class SubmitOrderEvent implements AnalyticsEvent {
  name = 'SubmitOrderEvent';
  constructor(public readonly order: OrderWithContext, public readonly isCustomTip: boolean, public readonly viewName: string | undefined | null) {}
}
